module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-16.0403b48b.png";